import { API, API_GET_TYPE } from "../../Config";

export const GetPolicy = () => {
  return API_GET_TYPE(API.getpolicy,1);
};
